"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _invariant = _interopRequireDefault(require("invariant"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _ViewModule = _interopRequireDefault(require("@material-ui/icons/ViewModule"));

var _ViewColumn = _interopRequireDefault(require("@material-ui/icons/ViewColumn"));

var _ViewHeadline = _interopRequireDefault(require("@material-ui/icons/ViewHeadline"));

var _ProductListPagerClassic = _interopRequireDefault(require("@sprinx/react-com/ProductListPagerClassic"));

var _ProductListHeader = _interopRequireDefault(require("@sprinx/react-com/ProductListHeader"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _content;

  return {
    root: {},
    content: (_content = {
      width: '100%',
      display: 'grid',
      gridTemplateColumns: '1fr 1fr 1fr 1fr'
    }, (0, _defineProperty2.default)(_content, theme.breakpoints.down('lg'), {
      gridTemplateColumns: '1fr 1fr 1fr'
    }), (0, _defineProperty2.default)(_content, theme.breakpoints.down('sm'), {
      gridTemplateColumns: '1fr 1fr'
    }), (0, _defineProperty2.default)(_content, theme.breakpoints.down('xs'), {
      gridTemplateColumns: '1fr'
    }), _content)
  };
}, {
  name: 'SxComProductList'
});

var _ref = /*#__PURE__*/_react.default.createElement(_ViewColumn.default, null);

var _ref2 = /*#__PURE__*/_react.default.createElement(_ViewModule.default, null);

var _ref3 = /*#__PURE__*/_react.default.createElement(_ViewHeadline.default, null);

var availableVariantsDefault = [{
  variant: 'cards',
  ButtonComponent: function ButtonComponent(props) {
    return /*#__PURE__*/_react.default.createElement(_Button.default, props, _ref);
  }
}, {
  variant: 'cards-big',
  ButtonComponent: function ButtonComponent(props) {
    return /*#__PURE__*/_react.default.createElement(_Button.default, props, _ref2);
  }
}, {
  variant: 'rows',
  ButtonComponent: function ButtonComponent(props) {
    return /*#__PURE__*/_react.default.createElement(_Button.default, props, _ref3);
  }
}];

var ProductList = /*#__PURE__*/_react.default.forwardRef(function ProductList(_ref4, ref) {
  var pAvailableVariants = _ref4.availableVariants,
      pClasses = _ref4.classes,
      className = _ref4.className,
      currency = _ref4.currency,
      children = _ref4.children,
      data = _ref4.data,
      _ref4$HeaderComponent = _ref4.HeaderComponent,
      Header = _ref4$HeaderComponent === void 0 ? _ProductListHeader.default : _ref4$HeaderComponent,
      imageAdornmentsHook = _ref4.imageAdornmentsHook,
      initialVariant = _ref4.initialVariant,
      _ref4$PagerComponent = _ref4.PagerComponent,
      Pager = _ref4$PagerComponent === void 0 ? _ProductListPagerClassic.default : _ref4$PagerComponent,
      pagination = _ref4.pagination,
      title = _ref4.title,
      rest = (0, _objectWithoutProperties2.default)(_ref4, ["availableVariants", "classes", "className", "currency", "children", "data", "HeaderComponent", "imageAdornmentsHook", "initialVariant", "PagerComponent", "pagination", "title"]);

  var _React$useState = _react.default.useState(initialVariant),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      variant = _React$useState2[0],
      setVariant = _React$useState2[1];

  var availableVariants = _react.default.useMemo(function () {
    return (pAvailableVariants || []).map(function (av) {
      return (0, _extends2.default)({}, availableVariantsDefault.find(function (i) {
        return i.variant === av.variant;
      }), av);
    });
  }, [pAvailableVariants]);

  var defaultVariant = availableVariants.find(function (_ref5) {
    var v = _ref5.variant;
    return v === variant;
  });
  (0, _invariant.default)(defaultVariant, "Invalid variant ".concat(initialVariant, ". Please use one of ").concat(availableVariants.map(function (_ref6) {
    var v = _ref6.variant;
    return v;
  })));
  var ItemComponent = defaultVariant.ItemComponent;
  var classes = useStyles({
    classes: pClasses
  });

  var handleChangeDisplayVariant = _react.default.useCallback(function (nextVariant) {
    return setVariant(nextVariant);
  }, []);

  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement(Header, {
    availableVariants: availableVariants,
    displayVariant: variant,
    onChangeDisplayVariant: handleChangeDisplayVariant
  }, children), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.content,
    ref: ref
  }, data.map(function (product, idx) {
    return /*#__PURE__*/_react.default.createElement(ItemComponent, {
      product: product,
      key: idx.toString(),
      currency: currency,
      imageAdornmentsHook: imageAdornmentsHook
    });
  })), /*#__PURE__*/_react.default.createElement(Pager, pagination));
});

process.env.NODE_ENV !== "production" ? ProductList.propTypes = {
  availableVariants: _propTypes.default.arrayOf(_propTypes.default.shape({
    ButtonComponent: _propTypes.default.elementType,
    // tlacitko prepinace variant
    ItemComponent: _propTypes.default.elementType.isRequired,
    // karta/radka produktu
    variant: _propTypes.default.string.isRequired // identifikator varianty

  })),
  children: _propTypes.default.node,
  classes: _propTypes.default.shape({
    content: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  currency: _propTypes.default.string.isRequired,
  data: _propTypes.default.arrayOf(_propTypes.default.shape({
    href: _propTypes.default.string.isRequired,
    id: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired
  })),
  HeaderComponent: _propTypes.default.elementType,
  imageAdornmentsHook: _propTypes.default.func,
  initialVariant: _propTypes.default.string,
  PagerComponent: _propTypes.default.elementType,
  pagination: _propTypes.default.shape({
    count: _propTypes.default.number,

    /**
     * Handler pro obsluhu zmeny stranky. Stranky jsou indexovanu od **1**.
     */
    onChangePage: _propTypes.default.func.isRequired,

    /**
     * Handler pro zmenu delky stranky.
     */
    onChangeRowsPerPage: _propTypes.default.func.isRequired,

    /**
     * Aktualni stranka. Indexovani od **1**.
     */
    page: _propTypes.default.number,
    rowsPerPage: _propTypes.default.number,

    /**
     * Moznosti pro pocet radku na jednu stranku.
     */
    rowsPerPageOptions: _propTypes.default.arrayOf(_propTypes.default.number)
  }),
  title: _propTypes.default.string
} : void 0;
ProductList.defaultProps = {
  availableVariants: undefined,
  children: null,
  classes: undefined,
  className: undefined,
  data: [],
  HeaderComponent: undefined,
  imageAdornmentsHook: undefined,
  initialVariant: 'card',
  PagerComponent: undefined,
  pagination: undefined,
  title: undefined
};
var _default = ProductList;
exports.default = _default;